module.exports = __webpack_public_path__ + "static/media/Koch Disruptive Technologies.348302fb.svg";